/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Return_Lot_Exceeds_ShippedInputs */

const vi_error_return_lot_exceeds_shipped = /** @type {(inputs: Error_Return_Lot_Exceeds_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số trả của lô vượt số còn trả được (đã xuất trừ các lần trả trước) hoặc lô không thuộc phiếu xuất của đơn. Tải lại popup để lấy số mới.`)
};

/**

* @param {Error_Return_Lot_Exceeds_ShippedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_return_lot_exceeds_shipped = /** @type {((inputs?: Error_Return_Lot_Exceeds_ShippedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Return_Lot_Exceeds_ShippedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_return_lot_exceeds_shipped(inputs)
});